// src/config.js

// Define the API URL based on your specific deployment needs.
// This is the value you currently have in your Login.js:
export const API_URL = "/pharmaapi"; //THIS IS FOR HOSTINGER
// export const API_URL = "http://localhost:5000/pharmaapi"; //THIS IS FOR LOCAL RUN

// You could also add other environment-specific configurations here later
// export const ITEMS_PER_PAGE = 10;
// export const TIMEOUT_SECONDS = 30;
